import { borderClassFromBgClass } from '@/lib/badgeBorderFromBackground';

export const MISSION_TYPE_DEFINITIONS = [
  {
    value: 'hourly',
    labelKey: 'missionsCreate.form.missionType.options.hourly',
    feeUnit: 'per_hour',
    feeSuffixKey: 'missionsCreate.form.fee.suffix.perHour',
  },
  {
    value: 'daily',
    labelKey: 'missionsCreate.form.missionType.options.daily',
    feeUnit: 'per_day',
    feeSuffixKey: 'missionsCreate.form.fee.suffix.perDay',
  },
  {
    value: 'monthly',
    labelKey: 'missionsCreate.form.missionType.options.monthly',
    feeUnit: 'per_month',
    feeSuffixKey: 'missionsCreate.form.fee.suffix.perMonth',
  },
  {
    value: 'deliverable',
    labelKey: 'missionsCreate.form.missionType.options.deliverable',
    feeUnit: 'per_deliverable',
    feeSuffixKey: 'missionsCreate.form.fee.suffix.perDeliverable',
  },
];

export const FEE_UNIT_DEFINITIONS = {
  per_hour: { labelKey: 'missionsCreate.form.fee.units.perHour' },
  per_day: { labelKey: 'missionsCreate.form.fee.units.perDay' },
  per_month: { labelKey: 'missionsCreate.form.fee.units.perMonth' },
  per_deliverable: { labelKey: 'missionsCreate.form.fee.units.perDeliverable' },
};

export const getMissionTypeOptions = (t) => {
  return MISSION_TYPE_DEFINITIONS.map(({ value, labelKey }) => ({
    value,
    label: t(labelKey),
  }));
};

export const getDefaultFeeUnit = (missionType) => {
  const definition = MISSION_TYPE_DEFINITIONS.find((item) => item.value === missionType);
  return definition?.feeUnit;
};

export const getFeeSuffixByType = (missionType, t) => {
  const definition = MISSION_TYPE_DEFINITIONS.find((item) => item.value === missionType);
  if (!definition) {
    return '';
  }

  return definition.feeSuffixKey ? t(definition.feeSuffixKey) : '';
};

export const getFeeUnitLabel = (feeUnit, t) => {
  const definition = FEE_UNIT_DEFINITIONS[feeUnit];
  if (!definition) {
    return feeUnit;
  }

  return t(definition.labelKey);
};

/** Titre du document Contrat Cadre (aligné avec le backend MA_DOCUMENT_TITLE). */
export const MA_DOCUMENT_TITLE = 'Contrat Cadre'

/**
 * Types de contrat de mission (alignés backend lib/constants/contractTypes.ts).
 * - services_agreement : mission avec documents classiques
 * - master_agreement   : mission liée au Contrat Cadre (MA)
 */
export const CONTRACT_TYPE_SERVICES_AGREEMENT = 'services_agreement'
export const CONTRACT_TYPE_MASTER_AGREEMENT = 'master_agreement'

/** True si le type de mission est Contrat Cadre. */
export function isMissionMasterAgreement(contractType) {
  return contractType === CONTRACT_TYPE_MASTER_AGREEMENT
}

/** Badge type de contrat — fond + bordure ~20 % plus foncée que le fond (comme statut mission). */
export function getMissionContractTypeBadgeClassName(contractType) {
  const base = isMissionMasterAgreement(contractType)
    ? 'bg-violet-100 text-violet-700'
    : 'bg-teal-100 text-teal-700';
  const bgClass = base.split(/\s+/).find((c) => c.startsWith('bg-'));
  const borderClass = bgClass ? borderClassFromBgClass(bgClass) : null;
  return borderClass ? `${base} ${borderClass}` : base;
}

/**
 * 文档签名状态常量
 * 对应后端返回的 signature_status 字段
 */
export const DOCUMENT_SIGNATURE_STATUS = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  PENDING_FREELANCER: 'PENDING_FREELANCER',
  PENDING_TEAM: 'PENDING_TEAM',
  SIGNED: 'SIGNED',
  REJECTED: 'REJECTED',
  FREELANCER_REJECTED: 'FREELANCER_REJECTED',
  TEAM_REJECTED: 'TEAM_REJECTED',
};

/**
 * 文档类型常量
 */
export const DOCUMENT_KIND = {
  MANUAL_REQUIRES_SIGNATURE: 'MANUAL_REQUIRES_SIGNATURE', // 需要签名的手动文档
  MANUAL_REFERENCE_ONLY: 'MANUAL_REFERENCE_ONLY', // 仅参考的手动文档
  TEMPLATE_REQUIRES_SIGNATURE: 'TEMPLATE_REQUIRES_SIGNATURE', // 需要签名的模板文档
  TEMPLATE_REFERENCE_ONLY: 'TEMPLATE_REFERENCE_ONLY', // 仅参考的模板文档
};
